
import React from "react";

import {Route , Routes} from "react-router-dom"
import Header from "../Layouts/Header";
import Home from "../Containers/HomeSection";
import Footer from "../Layouts/Footer";
import AboutUs from "../Containers/AboutusSection";
import Jewellery from "../Containers/Jewellery";
import Furniture from "../Containers/FurnitureSection"
import Articles from "../Containers/ArticlesSection";
import ContactUS from "../Containers/ContactUS";


const PublicRoutes = () => {
    return(

        <>
        <Routes>
            <Route exact path="/header" element= {<Header/>}/>
            <Route exact path="/about-us" element= {<AboutUs/>}/>
              <Route exact path="/Jewellery" element= {<Jewellery/>}/>
                 <Route exact path="/furniture" element= {<Furniture/>}/>
                  <Route exact path="/articles" element= {<Articles/>}/>
              <Route exact path="/contact-us" element= {<ContactUS/>}/>
            <Route exact path="/" element= {<Home/>}/>
        </Routes>
        <Footer/>
        </>
    )
}

export default PublicRoutes
